import { useEffect } from 'react';
import '../assets/iat-cursor.css';

// Efeito de luz amarela + bolinha que segue o mouse/toque.
// Usado nas telas de Login e Register. Cleanup remove o elemento e listeners.
export default function IatCursorGlow() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const dot = document.getElementById('cursor-dot');
    if (dot) dot.remove();

    let el = document.querySelector('.cursor-glow');
    let created = false;
    if (!el) {
      el = document.createElement('div');
      el.className = 'cursor-glow';
      el.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(el);
      created = true;
    }

    let raf = 0;
    const move = (x, y) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.left = x + 'px';
        el.style.top = y + 'px';
        el.classList.add('is-on');
      });
    };
    const hide = () => el.classList.remove('is-on');

    const onMouseMove = (e) => move(e.clientX, e.clientY);
    const onTouchStart = (e) => { const t = e.touches[0]; if (t) move(t.clientX, t.clientY); };
    const onTouchMove = (e) => { const t = e.touches[0]; if (t) move(t.clientX, t.clientY); };
    const onTouchEnd = (e) => { if (!e.touches.length) hide(); };

    window.addEventListener('mousemove', onMouseMove, { passive: true });
    document.addEventListener('mouseleave', hide);
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('touchcancel', hide, { passive: true });

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseleave', hide);
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
      document.removeEventListener('touchcancel', hide);
      if (created && el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  return null;
}
